import { number, select } from '@frameio/i18n';
import TEXT from './generated/TEXT/getPlanRate';

TEXT.DEFINE({
  /** Formatted plan rate string by billing period */
  rate: (planPeriod: string, cost: number): string =>
    select(planPeriod, {
      /** Monthly billing rate format */
      MONTHLY: `$${number(cost)}/mo`,
      /** Yearly billing rate format */
      YEARLY: `$${number(cost)}/yr`,
      /** Semi-annual billing rate format */
      SEMIANNUALLY: `$${number(cost)}/6mo`,
      /** Fallback for unknown billing period */
      other: '',
    }),
});

export const getPlanRate = (planPeriod: string, cost: number) =>
  TEXT.rate(planPeriod, cost);
